import { render, staticRenderFns } from "./SchoolTransactionsPageList.vue?vue&type=template&id=1ae0f780&lang=pug&"
import script from "./SchoolTransactionsPageList.vue?vue&type=script&lang=js&"
export * from "./SchoolTransactionsPageList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTransactionsPageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
